// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchBucket_icon__1vtrQ","value":"SearchBucket_value__2gsV-","margin":"SearchBucket_margin__p7Rhb","badge":"SearchBucket_badge__1iqlw"};